// La fiche d'information des formations (« L'essentiel sur la formation »),
// partagée par la page publique de chaque accélérateur et par son programme
// PDF, pour que les deux ne puissent pas se contredire.
//
// Les rubriques suivent l'ordre où le référentiel Qualiopi les énumère
// (indicateur 1) ; leurs textes vivent dans les clés trainingFacts_<programme>_*.
// Une rubrique sans texte pour un parcours (financements, suite de parcours
// pour Rocket, par exemple) n'y est simplement pas affichée.
// Le nombre d'objectifs varie d'un parcours à l'autre : il est déclaré ici,
// pas déduit des clés, pour qu'un objectif ajouté sans sa traduction se voie.

export const ROCKET_PRICE = 4500;

export const TRAINING_FACT_PROGRAMS = {
    rocket: {
        objectives: 6,
        title: "Développeur Web",
        subtitle: "Accélérateur Rocket",
    },
    python: {
        objectives: 4,
        title: "Python",
        subtitle: "Programmer et automatiser des tâches avec Python (Tosa)",
    },
};

export const TRAINING_FACT_ROWS = [
    { key: "audience", icon: "users-group-rounded-linear" },
    { key: "objectives", icon: "target-linear" },
    { key: "duration", icon: "clock-circle-linear" },
    { key: "access", icon: "calendar-linear" },
    { key: "price", icon: "wallet-linear" },
    { key: "funding", icon: "hand-money-linear" },
    { key: "methods", icon: "laptop-linear" },
    { key: "evaluation", icon: "checklist-minimalistic-linear" },
    { key: "certification", icon: "diploma-linear" },
    { key: "pathway", icon: "routing-2-linear" },
    { key: "results", icon: "chart-2-linear" },
    { key: "accessibility", icon: "accessibility-linear" },
    { key: "contact", icon: "letter-linear" },
];

// Les valeurs chiffrées injectées dans les textes de la fiche.
export function trainingFactValues(program) {
    // Le taux de satisfaction est celui de Rocket : tous les questionnaires de
    // fin reçus viennent de ses apprenants. Python, ouvert en 2026, n'en a pas
    // encore reçu : sa fiche l'écrit sans chiffre (un indicateur par formation).
    const rate = Number(process.env.BELIEVEMY_SATISFACTION_RATE);
    if (program === "rocket") {
        return { price: ROCKET_PRICE, rate };
    }
    return {};
}
